import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  formControl: {
    fontSize: "14px",
    height: "45px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .Mui-disabled": {
      color: "#000000",
    },
  },
}));

export default function CustomSelectUUID(props) {
  const {
    inputTitle,
    selectValue,
    handleSelectValueChange,
    data,
    name,
    isRequired,
  } = props;

  const classes = useStyles();

  // const labelId = inputTitle + "-simple-select-outlined-label";
  // const id = inputTitle + "-simple-select-outlined";
  const labelId = "test-simple-select-outlined-label";
  const id = "test-simple-select-outlined";

  return (
    <div className={classes.select}>
      {/* <text style={{ margin: "0.2rem 0rem" }}>{inputTitle}</text>{" "} */}
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id={labelId}>{inputTitle}</InputLabel>
        <Select
          disabled={props.disabled}
          required={isRequired}
          labelId={labelId}
          id={id}
          name={name}
          value={selectValue}
          onChange={handleSelectValueChange}
          variant="outlined"
          label={inputTitle}
          MenuProps={{ disablePortal: true }}
        >
          {data?.map((obj) => (
            <MenuItem key={obj.uuid} value={obj?.uuid}>
              {obj?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

CustomSelectUUID.defaultProps = {
  isRequired: false,
};

CustomSelectUUID.propTypes = {
  isRequired: PropTypes.bool,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
};
